import React from 'react'

import type { Layout } from '../styles'

interface CardContextValue {
  layout: Layout
}

const CardContext = React.createContext<CardContextValue>({
  layout: 'vertical',
})

export interface CardProviderProps {
  layout?: Layout
  children: React.ReactNode
}

export const CardProvider: React.FC<CardProviderProps> = ({
  layout = 'vertical',
  children,
}) => {
  const value = React.useMemo<CardContextValue>(
    () => ({ layout }),
    [layout],
  )

  return <CardContext.Provider value={value}>{children}</CardContext.Provider>
}

export const useCardContext = () => {
  return React.useContext(CardContext)
}
